import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EvsErr} from '../evsErr';
import {EvsStampService} from '../../../../common/services/EvsStamp.service';
import {ActivatedRoute, Params} from '@angular/router';
import {IOption} from 'ng-select';
import {EvsProductService} from '../../../../common/services/EvsProduct.service';
import {BatchstampService} from '../../qrcode/batchstamp/batchstamp.service';
import {EvsAddressService} from '../../../../common/services/EvsAddress.service';

declare var $: any;

@Component({
  selector: 'evs-activate-stamp-for-release',
  templateUrl: 'stamp-active-for-release.template.html',
  styleUrls: ['style.css'],
  providers: [EvsStampService, EvsProductService, BatchstampService, EvsAddressService]
})

export class StampActiveForReleaseComponent implements OnInit {
  title: string = 'Kích hoạt tem';
  public message: any = { class: 'alert-success', content: '' };
  public activateStampForm: FormGroup;

  public list_product: Array<IOption> = [];
  // public list_order:any = [];
  public list_order: Array<IOption> = [];
  public list_stamp_service: any = [];
  public action: string = 'active';
  btn_disable = false;
  required_stamp: boolean = false;

  public type_active: any = 'batch';

  public order_value: any;
  public start_value: any;
  public end_value: any;
  start_value_suggest: any;
  end_value_suggest: any;
  public list_value: any;
  order_name = '';
  total_stamp = 0;
  total_stamp_in_batch = 0;
  total_active = 0;
  list_store: Array<IOption> = [];
  list_city: Array<IOption> = [];
  list_district: Array<IOption> = [];
  public store_id: number = 0;
  public store_selected: any = {};
  to_address_value: any = '';
  selected_city: boolean = false;
  show_business = 1;
  guarantee_days_value: number = 0;

  constructor(private stampService: EvsStampService,
    private _fb: FormBuilder,
    private productService: EvsProductService,
    private batchService: BatchstampService,
    private addressService: EvsAddressService,
    private route: ActivatedRoute, ) {

  }


  ngOnInit() {

    // get list product
    this.getListProduct();
    // get stamp service
    // this.getListStampService();

    //get list order
    this.getListOrder();

    //
    this.getListCity();

    this.getListStore();

    // this.checkShowHiddenBlockInput(this.typeActive);
    this.createForm();


    $('#stamp-active-date-exp').datepicker({
      format: 'dd/mm/yyyy',
      // "setDate": new Date(),
    });

  }

  getListCity() {
    this.addressService.getCities().toPromise().then((res: any) => {
      if (res.statusCode) {
        let cities = [];
        for (let c of res.data.cities) {
          cities.push({ value: c.city_name, label: c.city_name, id: c.id })
        }
        this.list_city = cities;
      }
    });
  }

  getListDistrict(event) {
    let city_id = event.id;
    this.selected_city = true;
    this.addressService.getDistrict({ city_id: city_id }).toPromise().then((res: any) => {
      if (res.statusCode) {
        let districts = [];
        for (let d of res.data.districts) {
          districts.push({ value: d.district_name, label: d.district_name, id: d.id })
        }
        this.list_district = districts;
      }
    });
  }

  getListStore() {
    this.stampService.getAllStore({ desc: 'id', status: 1, limit: 500, deleted: 0 }).toPromise().then((res: any) => {
      if (res.status == 200) {
        let all_store = [];
        for (let p of res.data.store) {
          all_store.push({ value: p.id, label: p.name });
        }
        this.list_store = all_store;
      } else if (res.status == 400) {
        this.message.class = 'warning';
        this.message.content = res.message;
      } else {
        EvsErr.evs_err(res, false);
      }
    }).catch((err: any) => {
      EvsErr.evs_err(err);
    });
  }

  selectStore(ele) {
    this.store_id = ele.value;
    this.stampService.getStore(ele.value).toPromise().then((res: any) => {
      if (res.status == 200) {
        this.store_selected = res.data;
        this.to_address_value = res.data.address;
      } else if (res.status == 400) {
        this.message.class = 'warning';
        this.message.content = res.message;
      } else {
        EvsErr.evs_err(res, false);
      }
    }).catch((err: any) => {
      EvsErr.evs_err(err);
    });
  }

  deselectStore(ele) {
    this.store_id = 0;
    this.to_address_value = '';
  }

  getListProduct() {
    let params_getProduct: any = {};
    params_getProduct.fields = 'id,name';
    params_getProduct.status = 1;
    params_getProduct.asc = 'name';
    params_getProduct.limit = 100;
    this.productService.listProduct(params_getProduct).toPromise().then((res: any) => {
      if (res.error == false) {
        let all_pro = [];
        for (let p of res.data.products) {
          all_pro.push({ value: p.id, label: p.name });
        }
        this.list_product = all_pro;
        // console.log('this.list_product',this.list_product);
      } else {
        EvsErr.evs_err(res, false);
      }
    }).catch((err: any) => {
      EvsErr.evs_err(err);
    });
  }

  getListStampService() {
    this.stampService.listStampService().toPromise().then((res: any) => {
      if (res.error == false) {
        let listService: any = [];
        for (let _data of res.data) {
          listService[_data.id] = _data.name;
        }
        this.list_stamp_service = listService;
      } else {
        EvsErr.evs_err(res, false);
      }
    }).catch((err: any) => {
      EvsErr.evs_err(err);
    });
  }

  getListOrder() {
    this.stampService.listOrder({ status: 3, is_deleted: 0, limit: 500, desc: 'id' }).toPromise().then((res: any) => {
      // console.log('order',res);
      if (res.error == false) {
        let listO = [];
        for (let item of res.data.orders) {
          let obj = {
            'value': item.id,
            'label': item.name,
          };
          listO.push(obj);
        }
        this.list_order = listO;
        this.route.params.forEach((params: Params) => {
          let id = params['order_id'];
          if (id)
            this.select_order({
              'value': id
            });
          this.order_value = [parseInt(id)]
        })
      } else {
        EvsErr.evs_err(res, false);
      }
    }).catch((err: any) => {
      EvsErr.evs_err(err);
    });
  }

  static convertStampCodeToString(stamp_service: string = '', allService: any) {
    let stamp_service_text = '';
    if (stamp_service.indexOf('1') >= 0) {
      if (stamp_service_text != '') {
        stamp_service_text += ',' + allService[1];
      } else {
        stamp_service_text += allService[1];
      }
    }
    if (stamp_service.indexOf('2') >= 0) {
      if (stamp_service_text != '') {
        stamp_service_text += ',' + allService[1];
      } else {
        stamp_service_text += allService[1];
      }

    }
    if (stamp_service.indexOf('3') >= 0) {
      if (stamp_service_text != '') {
        stamp_service_text += ',' + allService[3];
      } else {
        stamp_service_text += allService[3];
      }
    }
    if (stamp_service.indexOf('4') >= 0) {
      if (stamp_service_text != '') {
        stamp_service_text += ',' + allService[4];
      } else {
        stamp_service_text += allService[4];
      }
      // serial = _data.guarantee_days + ' ngày';
    }
    return stamp_service_text;
  }

  createForm() {

    let now = new Date();
    let dd = now.getDate();
    let mm = now.getMonth() + 1; //January is 0!

    let yyyy = now.getFullYear();
    let dd2: string;
    let mm2: string;
    dd2 = dd < 10 ? '0' + dd : '' + dd;
    mm2 = mm < 10 ? '0' + mm : '' + mm;
    let today = dd2 + '/' + mm2 + '/' + yyyy;

    this.activateStampForm = this._fb.group({
      select_type_active: [null],
      order_id: [null, [Validators.required]],
      start: [null],
      end: [null],
      list: [null],

      item_id: [null, [Validators.required]],
      status: ['active', [Validators.required]],

      expire_time: [today],
      guarantee_days: [this.guarantee_days_value],
      type_guarantee_days: ['d'],

      store_id: [null],
      to_city: [null],
      to_district: [null],
      to_address: [null],
      show_business: [this.show_business]

      // sku: [null, [Validators.required]],
      // status: '1',
      // description: [''],

    });
  }

  onSubmit(data: any) {
    this.btn_disable = true;
    let request: any = {};
    if (data.store_id > 0) {
      request.store_id = data.store_id;
      if (this.store_selected.province) {
        request.to_city = this.store_selected.province;
      }
      if (this.store_selected.district) {
        request.to_district = this.store_selected.district;
      }
      if (this.store_selected.address) {
        request.to_address = this.store_selected.address;
      }
    } else {
      if (data.to_city) {
        request.to_city = data.to_city;
      }
      if (data.to_district) {
        request.to_district = data.to_district;
      }
      if (data.to_address) {
        request.to_address = data.to_address;
      }
    }


    if (data.select_type_active == 'batch') {
      if (data.start && data.end) {
        // request.start = this.serialToNumber(data.start);
        // request.end = this.serialToNumber(data.end);
        // this.total_stamp = request.end - request.start + 1;
        request.start = data.start;
        request.end = data.end;
      } else {
        // this.total_stamp = this.total_stamp_in_batch;
      }
    } else if (data.select_type_active == 'list') { // list
      if (data.list) {
        let arr_list = data.list.split(',');
        // this.total_stamp = arr_list.length;
        let list = [];
        for (let item of arr_list) {
          // list.push(this.serialToNumber(item));
          list.push(item);
        }
        request.list = list;
      } else {
        // this.total_stamp = this.total_stamp_in_batch;
      }
    } else { // cả lô

    }

    request.item_id = data.item_id;
    request.order_id = data.order_id;
    request.show_business = data.show_business ? 1 : 0;

    let expire_time = $('#stamp-active-date-exp').val();
    if (expire_time) {
      let ar_time = expire_time.split('/');
      let d = new Date(parseInt(ar_time[2]), parseInt(ar_time[1]) - 1, parseInt(ar_time[0]), 23, 59, 59);
      request.expire_time = d.getTime() / 1000;

      // let d=new Date(expire_time);
      // // request.expire_time = (d.getTime()+(60*60*24*1000))/1000;
      // request.expire_time = (d.getTime())/1000;
    } else {
      request.expire_time = 0;
    }

    if (data.type_guarantee_days == 'm') {
      request.guarantee_days = data.guarantee_days * 31;
    }
    else if (data.type_guarantee_days == 'y') {
      request.guarantee_days = data.guarantee_days * 365;
    } else {
      request.guarantee_days = data.guarantee_days;
    }

    request.typeUpdate = 0; // 0: kich hoat, 1: phân phối

    // console.log('data',data);
    // console.log('request',request);

    $('#stamp-active-message').hide(100);
    this.stampService.changeStampStatusWithSerial(request, data.status).toPromise().then((res: any) => {
      this.btn_disable = false;
      if (res.error == false) {
        this.total_active = res.data.nModified;
        this.message.class = 'success';
        this.message.content = 'Yêu cầu kích hoạt tem đang được thực hiện!';
        $('#stamp-active-message').show(200);
        $('#activeSuccessAlert').modal();
      } else {
        // this.message.class = 'warning';
        // this.message.content = 'Kích hoạt chưa thành công. Vui lòng thử lại';
        // $('#stamp-active-message').show(200);
        //
        // EvsErr.evs_err(res, false);
        // let body = $('html, body');
        // body.stop().animate({scrollTop: 0}, 500, 'swing', function () {
        // });
        this.message.class = 'warning';
        this.message.content = 'Kích hoạt chưa thành công. Vui lòng thử lại!';
        $('#stamp-active-message').show(200);
        $('#activeSuccessAlert').modal();
      }
    }).catch((err: any) => {
      this.btn_disable = false;
      // this.message.class = 'warning';
      // this.message.content = 'Kích hoạt chưa thành công. Vui lòng thử lại';
      // EvsErr.evs_err(err, false);
      // let body = $('html, body');
      // body.stop().animate({scrollTop: 0}, 500, 'swing', function () {
      // });
      this.message.class = 'warning';
      this.message.content = 'Kích hoạt chưa thành công. Vui lòng thử lại!';
      $('#stamp-active-message').show(200);
      $('#activeSuccessAlert').modal();
    });
  }

  select_order(event) {
    let order_id = event.value;
    // batchService
    this.batchService.getDetailsOrder(order_id).subscribe(
      res => {
        if (res.status == 200) {
          this.order_name = res.data.name;
          this.start_value = this.start_value_suggest = this.formatSerial(res.data.id_start, res.data.prefix);
          this.end_value = this.end_value_suggest = this.formatSerial(res.data.id_end, res.data.prefix);
          this.total_stamp_in_batch = res.data.quantity;
        } else if (res.status == 400) {
          this.message.class = 'warning';
          this.message.content = res.status;
          let body = $('html, body');
          body.stop().animate({ scrollTop: 0 }, 500, 'swing', function () {
          });
        }
      });
  }

  formatSerial(serial, prefix: string = '') {
    let format_serial: string;
    let prefix2 = prefix ? prefix + '-' : '';
    serial = serial.toString();
    if (serial.length > 6) {
      format_serial = prefix2 + serial;
    } else {
      let pad = '000000';
      format_serial = prefix2 + pad.substring(0, 6 - serial.length) + serial;
    }

    return format_serial;
  }

  serialToNumber(serial) {
    let _serial = serial.split('-');
    if (_serial.length == 1) {
      return parseInt(_serial[0]);
    } else {
      return parseInt(_serial[1]);
    }
  }


  empty(data) {
    if (typeof (data) == 'number' || typeof (data) == 'boolean') {
      return false;
    }
    if (typeof (data) == 'undefined' || data === null) {
      return true;
    }
    if (typeof (data.length) != 'undefined') {
      return data.length == 0;
    }
    let count = 0;
    for (let i in data) {
      if (data.hasOwnProperty(i)) {
        count++;
      }
    }
    return count == 0;
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/stamp/stamp-active-for-release.component.ts